import MyassaysLayoutViewer from './MyassaysLayoutViewer';

customElements.define('myassays-layout-viewer', MyassaysLayoutViewer);

export default MyassaysLayoutViewer;
